import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, ready, login } = useAuth();
  const [email, setEmail] = useState("admin@icefleet.is");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    document.title = "IceFleet · Admin Login";
  }, []);

  if (ready && user) return <Navigate to={loc.state?.from || "/admin"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const r = await login(email, password);
    setBusy(false);
    if (r.ok) {
      toast.success("Welcome back.");
      nav(loc.state?.from || "/admin", { replace: true });
    } else {
      toast.error(r.error);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-5">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-sm rounded-xl border border-slate-200 bg-white p-8 space-y-5">
        <div>
          <p className="text-xs font-bold uppercase tracking-widest text-sky-700">Admin</p>
          <h1 className="font-heading text-2xl font-semibold tracking-tight mt-1">Sign in</h1>
        </div>
        <label className="block">
          <span className="text-xs font-semibold uppercase tracking-wider text-slate-700">Email</span>
          <input
            type="email"
            required
            data-testid="admin-login-email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1.5 w-full rounded-md border border-slate-300 px-3 py-2.5 text-sm focus:border-slate-900 focus:ring-1 focus:ring-slate-900 outline-none"
          />
        </label>
        <label className="block">
          <span className="text-xs font-semibold uppercase tracking-wider text-slate-700">Password</span>
          <input
            type="password"
            required
            data-testid="admin-login-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-1.5 w-full rounded-md border border-slate-300 px-3 py-2.5 text-sm focus:border-slate-900 focus:ring-1 focus:ring-slate-900 outline-none"
          />
        </label>
        <button
          type="submit"
          disabled={busy}
          data-testid="admin-login-submit"
          className="w-full rounded-md bg-slate-900 px-5 py-3 text-sm font-semibold text-white hover:bg-slate-800 disabled:opacity-60"
        >
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
